import { render, staticRenderFns } from "./demanDatails.vue?vue&type=template&id=61ec1e73&scoped=true"
import script from "./demanDatails.vue?vue&type=script&lang=js"
export * from "./demanDatails.vue?vue&type=script&lang=js"
import style0 from "./demanDatails.vue?vue&type=style&index=0&id=61ec1e73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec1e73",
  null
  
)

export default component.exports